import React, { useState, useEffect } from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Dropdown from '../Reusables/Dropdown';
import '../../scss/projectnew.scss';
import '../Reusables/Calender'
import getResponse from '../actions/Project';
import Calender from '../Reusables/Calender';
import Descriptor from '../Reusables/Descriptor';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import Spinner from '../Reusables/Spinner';
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';
import { trim } from '../Reusables/Function';
import { convertToDateString } from '../Reusables/Function';
import MultiSelectionDropdown from '../Reusables/MultiSelectionDropdown';

function ProjectNew(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [entityList, setEntityList] = useState([]);
    const [projectname, setProjectname] = useState(null);
    const [entityid, setEntityId] = useState([]);
    const [date, setDate] = useState(null);
    const [adestraReport, setAdestraReport] = useState(null);
    const [description, setDescription] = useState(null);
    const [entityLabel, setEntityLabel] = useState('Select Property');
    const [projectTypeLabel, setprojectTypeLabel] = useState('Select Project Type');
    const [projectTypeid, setProjectTypeId] = useState(null);
    const [projectTypeList, setProjectTypeList] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [startdate, setStartDate] = useState(false);
    const [label, setLabel] = useState('Select Date');
    const [error, setError] = useState('');
    const [enable, setEnable] = useState(true);
    const [open, setOpen] = useState(null);
    const [projectTypeEnable, setProjectTypeEnable] = useState(null);

    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Projects", "url": "projects/list" },
        { "name": "Project New", "url": "projects/new" }
    ];

    function GetDropdown() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                const endpoint = "/api/entity/dropdown";
                getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => {   
                    if(response.status == 200) {
                        const entityArray = [];
                        response.data.data.map((task) => {
                            const entityObject = {id: 0, name: ''}
                            entityObject.id = task["idEntities"];
                            entityObject.name = task["entityName"];
                            entityObject.propertyCode = task["entityName"].split(' -')[0]
                            entityObject.brandId = task["brandId"];
                            entityObject.parentBrand = task["parentBrand"]
                            entityArray.push(entityObject);
                        })
                        setEntityList(entityArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }   
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    
    function CreateProject() {
        setEnable(false);
        let datetime = date;
        var exactdate = null
        if(datetime != null && datetime != "") {
            // Generate yyyy-mm-dd date string
            exactdate = convertToDateString(datetime, "")
        }
        console.log("Date", exactdate);
        const data = {
            "Name" : trim(projectname),
            "DueDate": exactdate,
            "EntityIds": entityid,
            "ProjectTypeId": projectTypeid,
            "Description": trim(description),
            "AdestraReport": trim(adestraReport)
        }
        console.log("DATA", data);

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.CreateProject(data, accesstoken, (response) => {  
                    setEnable(true);     
                    console.log("response", response);
                    if(response.status === 200) {
                        setLoading(true);
                        navigate('/projects/list?category=Active');
                        window.scroll(0, 0);
                        setOpen(false);
                    }
                    if(response.status === 400) {
                        setLoading(false);
                        setError(response.data.message);
                        setOpen(true);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    function handledate(date) {
        setDate(date);
        setStartDate(date);
    }
    useEffect(() => {
        setOpen(false)
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        GetDropdown();
        setLoading(false);
    }, [])

    const handleEntityDropdown = (ids) => {
        setEntityId(ids);

        if(ids.length > 0) {
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                }
                else {
                    getResponse.GetProjectList(`/api/brand/projecttypes?entityId=${ids[0]}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            const templateArray = [];
                            data.data.data.map((template) => {
                                const templateObject = {id: 0, name: ''}
                                templateObject.id = template["idProjectType"];
                                templateObject.name = template["projectTypeName"];
                                templateArray.push(templateObject);
                            })
                            setProjectTypeList(templateArray);
    
                            templateArray.length > 0 ? setProjectTypeEnable(true) : resetProjectType();
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
    
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        } else {
            resetProjectType();
        }
    }

    const resetProjectType = () => {
        setProjectTypeEnable(false);
        setProjectTypeList([]);
        setprojectTypeLabel('Select Project Type');
        setProjectTypeId(null);
    }

    return (
        <div className='project-new-container'>
            <Header />
            <div className='row project-new-section'>
                <Sidebar />
                <div className='col-10 project-new-right'>
                    <Breadcrumbs />
                    {isLoading ? 
                        (<Spinner/>) :
                        (<div className='project-new-content'>
                            <div className='row label-input-row'>
                                <div className='col-4 label-input-col'>
                                    <div className='label-input label-input-name'>
                                        <label className='required'>Name</label>
                                        <div className='input-box'> 
                                            <input type="text" value={projectname ? projectname : ''} onChange={(e) => setProjectname(e.target.value)}
                                            maxLength={200}></input>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4 label-input-col'>
                                    <div className='label-input label-input-due'>
                                        <label className='required'>Due Date</label>
                                        <Calender minDate={new Date()} maxDate={false} startdate={startdate} 
                                            HandleDate={(date) => handledate(date)} 
                                            HandleLabel={(date) => setLabel(convertToDateString(date, "picker"))} label={label}
                                            disablefromto={false} disableto={false}
                                        />
                                    </div>
                                </div>
                                <div className='col-4 label-input-col'>
                                    <div className='label-input label-input-entity'>
                                        <label className='required'>Property</label>
                                        {/* <Dropdown label={entityLabel} selectedItem={(name, id) => handleEntityDropdown(id)}
                                            handleLabel={(value) => setEntityLabel(value)} list={entityList} enable={true} searchbar={true}/> */}
                                        {
                                            <MultiSelectionDropdown label={entityLabel} selectedItem={(ids) => handleEntityDropdown(ids)}
                                                handleLabel={(value) => setEntityLabel(value)} list={entityList}
                                                selectedEntity={[]} selectedBrand={0}/>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row project-type-row'>
                                <div className='col-4 label-input-col'>
                                    <div className={projectTypeEnable ? 'label-input label-input-entity pointer-all' : 'label-input label-input-entity pointer-none'}>
                                        <label className={projectTypeEnable ? '' : 'dropdown-grey'}>Project Type</label>
                                        <Dropdown label={projectTypeLabel} selectedItem={(name, id) => setProjectTypeId(id)}
                                            handleLabel={(value) => setprojectTypeLabel(value)} list={projectTypeList} enable={projectTypeEnable}/>
                                    </div>
                                </div>
                            </div>
                            <div className='row report-input-row'>
                                <div className='col-12 label-input-col report-input'>
                                    <div className='label-input label-input-name'>
                                        <label>Adestra Report</label>
                                        <div className='input-box'> 
                                            <input type="text" value={adestraReport ? adestraReport : ''} onChange={(e) => setAdestraReport(e.target.value)}
                                            maxLength={200}></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row description-row'>
                                <div className='col-12'>
                                    <label>Description</label>
                                    <Descriptor setDescription={setDescription}/>
                                </div>
                                <div className='save-button'>
                                    <button disabled={enable ? false : true} className={enable ? 'enable' : 'disable'} onClick={CreateProject}>Save</button>
                                </div>
                            </div>
                        </div>)
                    }
                </div>
            </div>  
            <Snackbars error={error} open={open} setOpen={setOpen}/>
            <Footer />
        </div>  
    );
}

export default ProjectNew;